import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { DIGITAL_SAVE_DRAFT, DIGITAL_SAVE_DRAFT_SUCCESS, DIGITAL_SAVE_DRAFT_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* digitalSaveDraft({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/other-gm-prices`,
      method: 'POST',
      data: payload.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: DIGITAL_SAVE_DRAFT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: DIGITAL_SAVE_DRAFT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DIGITAL_SAVE_DRAFT_ERROR, payload: error });
  }
}

export function* watchDigitalSaveDraft() {
  yield takeEvery(DIGITAL_SAVE_DRAFT, digitalSaveDraft);
}

function* digitalSaveDraftSaga() {
  yield all([fork(watchDigitalSaveDraft)]);
}

export default digitalSaveDraftSaga;
